function cleanString(str: string) {
  return str.split(' ').filter(item => item);
}

export function getHighlightedWords(
  originalString: string,
  correctedString: string,
): Array<{ same: boolean; text: string }> {
  if (correctedString) {
    const cleanedCorrectedString = correctedString.replace(/"/g, '');
    const cleanedOriginalString = originalString.replace(/"/g, '');
    const correctedWords = cleanString(cleanedCorrectedString);
    const originalWords = cleanString(cleanedOriginalString);

    const editedWords = correctedWords.filter(
      (word, index) => word !== originalWords[index],
    );
    const result = editedWords.reduce(
      (
        acc: {
          text: string;
          words: Array<{ text: string; same: boolean }>;
        },
        word,
      ) => {
        const index = acc.text.indexOf(word);
        acc.words.push({
          text: acc.text.slice(0, index),
          same: true,
        });
        acc.words.push({
          text: acc.text.slice(index, index + word.length),
          same: false,
        });
        acc.text = acc.text.slice(index + word.length);
        return acc;
      },
      {
        text: correctedString,
        words: [],
      },
    );
    const { words, text } = result;

    if (text) {
      words.push({ same: true, text });
    }

    return words;
  }
  return [];
}
